import styled from "styled-components";

import { StealDealOrderDetailsWrapper } from "../styles";

export const CouponDetailsWrapper = styled(StealDealOrderDetailsWrapper)(({ theme }) => ({
    boxSizing: "content-box",
    "& *": { boxSizing: "content-box" },
    margin: `0 ${theme.spacing.medium} 0`,
    marginBottom: theme.spacing.small,
}));
